import { render, staticRenderFns } from "./userMymsg.vue?vue&type=template&id=722665d9&scoped=true"
import script from "./userMymsg.vue?vue&type=script&lang=js"
export * from "./userMymsg.vue?vue&type=script&lang=js"
import style0 from "./userMymsg.vue?vue&type=style&index=0&id=722665d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722665d9",
  null
  
)

export default component.exports